module.exports = __webpack_public_path__ + "static/media/warning_icon.5f586077.svg";